var env = require("../utils/env");
var apiDomain = env.domain.api;
var Auth = require("./auth");
var request = require('superagent');
var async = require('async');

var exports = module.exports = {};

exports.saveStudentClass = function(studentClass, callback) {
    callback = callback || function() {};
    var tmpCollection = JSON.parse(JSON.stringify(studentClass));
    // delete tmpCollection.questions;
    // console.log("UPDATING CLASS WITH ID " + studentClass._id);
    if (studentClass._id) {
        request
            .put(apiDomain + '/v1/studentclasses/' + studentClass._id)
            .withCredentials()
            .send(tmpCollection)
            .then(function(response) {
                var newStudentClass = Object.assign(studentClass, response.body);
                saveNewStudentClass(newStudentClass, function(err1, resArr) {
                    // newStudentClass.questions = resArr;
                    return callback(err1, newStudentClass);
                })
            }, function(err) {
                return callback(err);
            })
    } else {
        request
            .post(apiDomain + '/v1/studentclasses')
            .withCredentials()
            .send(tmpCollection)
            .then(function(response) {
                var newStudentClass = Object.assign(studentClass, response.body);
                saveNewStudentClass(newStudentClass, function(err1, resArr) {
                    // newCollection.questions = resArr;
                    return callback(err1, newStudentClass);
                });
            }, function(err) {
                return callback(err);
            })
    }
}

var saveNewStudentClass = function(studentClass, cb) {

    var callbackArr = [];
    // for (var i = 0; i < collection.questions.length; i++) {
    //     kQuestions.push(collection.questions[i].kquestion);
    //     createQuestionsTask(callbackArr, kQuestions[i], i, collection);
    // }

    async.series(callbackArr, function(err, resArr) {
        if (cb) return cb(err, resArr);
    })
}

// var deleteStudentClass = function(studentClass, cb) {

//     var callbackArr = [];
//     // for (var i = 0; i < collection.questions.length; i++) {
//     //     kQuestions.push(collection.questions[i].kquestion);
//     //     createQuestionsTask(callbackArr, kQuestions[i], i, collection);
//     // }

//     async.series(callbackArr, function(err, resArr) {
//         if (cb) return cb(err, resArr);
//     })
// }

exports.deleteStudentClass = function(studentClass, callback) {

    callback = callback || function() {};
    // var tmpCollection = JSON.parse(JSON.stringify(studentClass));

    if (studentClass._id) {
        request
            .delete(apiDomain + '/v1/studentclasses/' + studentClass._id)
            .withCredentials()
            .then(function(response) {
                return callback(null, response);
            }, function(err) {
                return callback(err);
            })
            // .send(tmpCollection)
            // .then(function(response) {
            //     var deletedStudentClass = Object.assign(studentClass, response.body);
            //     deleteStudentClass(deletedStudentClass, function(err1, resArr) {
            //         // newStudentClass.questions = resArr;
            //         return callback(err1, deletedStudentClass);
            //     })
            // }, function(err) {
            //     return callback(err);
            // })
    }
}

exports.retrieveStudentClasses = function(options, callback) {

    var currentUser = Auth.currentUser;

    callback = callback || function() {};
    options = options || {};
    options.conditions = options.conditions || {};
    // if (currentUser.role === 'admin') {
    //
    // } else {
    //   options.conditions.creator = currentUser._id;
    // }
    // if (currentUser.role !== 'admin' && !options.conditions.creator) {
    //     options.conditions.creator = currentUser._id;
    // }

    console.log(options);
    request
        .get(apiDomain + '/v1/studentclasses')
        .query({
            sort: options.sort,
            limit: options.limit,
            skip: options.skip,
            conditions: JSON.stringify(options.conditions),
            include: options.include,
            conditions1: JSON.stringify(options.includeConditions)
        })
        .then(function(response) {
            return callback(null, response.body);
        }, function(err) {
            var ERR;
            if (err.response) ERR = err.response.body;
            else ERR = err;
            return callback(ERR);
        })
}

exports.retrieveStudentsInThisClass = function(options, callback) {

    var currentUser = Auth.currentUser;

    callback = callback || function() {};
    options = options || {};
    options.conditions = options.conditions || {};
    // if (currentUser.role === 'admin') {
    //
    // } else {
    //   options.conditions.creator = currentUser._id;
    // }
    // if (currentUser.role !== 'admin' && !options.conditions.creator) {
    //     options.conditions.creator = currentUser._id;
    // }

    console.log(options);
    request
        .get(apiDomain + '/v1/studentclasses/' + options.conditions.studentClassID)
        .query({
            sort: options.sort,
            // limit: options.limit,
            // skip: options.skip,
            conditions: JSON.stringify(options.conditions),
            // include: options.include,
            conditions1: JSON.stringify(options.includeConditions)
        })
        .then(function(response) {
            return callback(null, response.body);
        }, function(err) {
            var ERR;
            if (err.response) ERR = err.response.body;
            else ERR = err;
            return callback(ERR);
        })
}

exports.retrieveAllStudentsInMyClasses = function(options, callback) {

    var currentUser = Auth.currentUser;

    callback = callback || function() {};
    options = options || {};
    options.conditions = options.conditions || {};
    // if (currentUser.role === 'admin') {
    //
    // } else {
    //   options.conditions.creator = currentUser._id;
    // }
    // if (currentUser.role !== 'admin' && !options.conditions.creator) {
    //     options.conditions.creator = currentUser._id;
    // }

    console.log(options);
    request
        .get(apiDomain + '/v1/studentclasses/allstudents/' + options.conditions.teacherID)
        .query({
            sort: options.sort,
            // limit: options.limit,
            // skip: options.skip,
            conditions: JSON.stringify(options.conditions),
            // include: options.include,
            conditions1: JSON.stringify(options.includeConditions)
        })
        .then(function(response) {
            return callback(null, response.body);
        }, function(err) {
            var ERR;
            if (err.response) ERR = err.response.body;
            else ERR = err;
            return callback(ERR);
        })
}


/** WEBPACK FOOTER **
 ** ./src/resources/studentclass.js
 **/